import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/matteklar';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p26wqcx7djr7">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6viucutjfap8">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1v4xm8xdzn6i">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="1u3a34z6p87w">
            Hvem er <em className="text-red-700" data-id="element-23" data-mp="gqsx5krrfm42">NATURFAG KLAR™</em> for?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="btax6jvq0h87">Pakken er for deg som:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="pkphqv5a0qhd">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="llqfjiaxj7tm">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ukbu72da62p4" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-28" data-mp="16esxqzy0pu7g">
            Laget for lærere som vil bruke mindre tid på forberedelser og mer tid på elevene.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-29" data-mp="1gd8pn54vd7i0">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-30" data-mp="1kan0104adlbl">Hva er tiden din verdt?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-31" data-mp="1p9q0s8d8h5dr">
            Tenk på hvor mange timer du bruker på å planlegge naturfag hver uke:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-32" data-mp="1z2ovm7zbps5t">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-33" data-mp="24073dv1lu1c8">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="280ha59x80vs5">
            Tenk deg nå en organisert pakke som hjelper deg med alt dette – hele skoleåret.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-35" data-mp="czovl2a03nie">
            Du trenger ikke fortsette å begynne fra null.
          </p>
        </aside>
      </div>
    </section>;
}